// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.channel-prompt-modal_channel_backdrop__liCta {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(2px);
  z-index: 105000;
  opacity: 0;
  animation: channel-prompt-modal_fadeIn__OUe7o 0.3s ease forwards;
}

.channel-prompt-modal_channel_modal_overlay__uDV9\\+ {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 105001;
}

.channel-prompt-modal_channel_modal__r8Egd {
  background-color: white;
  border-radius: 16px;
  padding: 32px;
  width: 100%;
  max-width: 420px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
  transform: translate(-50%, -50%) scale(0.95);
  position: fixed;
  top: 50%;
  left: 50%;
  opacity: 0;
  animation: channel-prompt-modal_popIn__ts6c1 0.4s cubic-bezier(0.16, 1, 0.3, 1) forwards;
  animation-delay: 0.1s;
}
@media (max-width: 768px) {
  .channel-prompt-modal_channel_modal__r8Egd {
    max-width: calc(100% - 32px);
    padding: 24px;
  }
}

.channel-prompt-modal_logo_container__rqLQB {
  display: flex;
  justify-content: center;
  margin-bottom: 24px;
}
.channel-prompt-modal_logo_container__rqLQB img {
  max-width: 160px;
  height: auto;
}

.channel-prompt-modal_channel_title__sYVpQ {
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 8px;
  color: #0a2544;
  text-align: center;
  letter-spacing: -0.5px;
}
@media (max-width: 768px) {
  .channel-prompt-modal_channel_title__sYVpQ {
    font-size: 24px;
  }
}

.channel-prompt-modal_channel_subtitle__oxEe0 {
  text-align: center;
  color: #6b7280;
  margin-bottom: 32px;
  font-size: 16px;
  line-height: 1.5;
}

.channel-prompt-modal_channel_actions__Qn3fM {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.channel-prompt-modal_channel_button__MZTpR {
  padding: 20px 24px;
  background-color: var(--primary, #3b82f6);
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  width: 100%;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  gap: 16px;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.2);
}
.channel-prompt-modal_channel_button__MZTpR::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transition: 0.5s;
}
.channel-prompt-modal_channel_button__MZTpR:hover {
  background-color: #2563eb;
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(59, 130, 246, 0.3);
}
.channel-prompt-modal_channel_button__MZTpR:hover::before {
  left: 100%;
}
.channel-prompt-modal_channel_button__MZTpR:active {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.2);
}

.channel-prompt-modal_sms_button__EG-G9 {
  background-color: #10b981;
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.2);
}
.channel-prompt-modal_sms_button__EG-G9:hover {
  background-color: #059669;
  box-shadow: 0 6px 16px rgba(16, 185, 129, 0.3);
}
.channel-prompt-modal_sms_button__EG-G9:active {
  box-shadow: 0 2px 8px rgba(16, 185, 129, 0.2);
}

.channel-prompt-modal_button_icon__qEWqz {
  font-size: 24px;
  flex-shrink: 0;
}

.channel-prompt-modal_button_content__xbEJs {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1 1;
}

.channel-prompt-modal_button_title__F\\+Xfw {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 2px;
}

.channel-prompt-modal_button_subtitle__Ss51O {
  font-size: 14px;
  font-weight: 400;
  opacity: 0.9;
}

@keyframes channel-prompt-modal_fadeIn__OUe7o {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes channel-prompt-modal_popIn__ts6c1 {
  from {
    opacity: 0;
    transform: translate(-50%, -48%) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/channel-prompt-modal/channel-prompt-modal.module.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EAEA,0BAAA;EACA,eAAA;EACA,UAAA;EACA,gEAAA;AACF;;AAEA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,6BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AACF;;AAEA;EACE,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,WAAA;EACA,gBAAA;EACA,2CAAA;EACA,4CAAA;EACA,eAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,wFAAA;EACA,qBAAA;AACF;AACE;EAfF;IAgBI,4BAAA;IACA,aAAA;EAEF;AACF;;AACA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AAEF;AAAE;EACE,gBAAA;EACA,YAAA;AAEJ;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;AACF;AACE;EARF;IASI,eAAA;EAEF;AACF;;AACA;EACE,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AAEF;;AACA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAEF;;AACA;EACE,kBAAA;EACA,yCAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,8CAAA;AAEF;AAAE;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,sFAAA;EAMA,gBAAA;AAHJ;AAME;EACE,yBAAA;EACA,2BAAA;EACA,8CAAA;AAJJ;AAMI;EACE,UAAA;AAJN;AAQE;EACE,wBAAA;EACA,6CAAA;AANJ;;AAUA;EACE,yBAAA;EACA,8CAAA;AAPF;AASE;EACE,yBAAA;EACA,8CAAA;AAPJ;AAUE;EACE,6CAAA;AARJ;;AAYA;EACE,eAAA;EACA,cAAA;AATF;;AAYA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;AATF;;AAYA;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;AATF;;AAYA;EACE,eAAA;EACA,gBAAA;EACA,YAAA;AATF;;AAYA;EACE;IACE,UAAA;EATF;EAWA;IACE,UAAA;EATF;AACF;AAYA;EACE;IACE,UAAA;IACA,4CAAA;EAVF;EAaA;IACE,UAAA;IACA,yCAAA;EAXF;AACF","sourcesContent":[".channel_backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  -webkit-backdrop-filter: blur(2px);\n  backdrop-filter: blur(2px);\n  z-index: 105000;\n  opacity: 0;\n  animation: fadeIn 0.3s ease forwards;\n}\n\n.channel_modal_overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: transparent;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 105001;\n}\n\n.channel_modal {\n  background-color: white;\n  border-radius: 16px;\n  padding: 32px;\n  width: 100%;\n  max-width: 420px;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);\n  transform: translate(-50%, -50%) scale(0.95);\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  opacity: 0;\n  animation: popIn 0.4s cubic-bezier(0.16, 1, 0.3, 1) forwards;\n  animation-delay: 0.1s;\n\n  @media (max-width: 768px) {\n    max-width: calc(100% - 32px);\n    padding: 24px;\n  }\n}\n\n.logo_container {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 24px;\n\n  img {\n    max-width: 160px;\n    height: auto;\n  }\n}\n\n.channel_title {\n  font-size: 28px;\n  font-weight: 700;\n  margin-bottom: 8px;\n  color: #0a2544;\n  text-align: center;\n  letter-spacing: -0.5px;\n\n  @media (max-width: 768px) {\n    font-size: 24px;\n  }\n}\n\n.channel_subtitle {\n  text-align: center;\n  color: #6b7280;\n  margin-bottom: 32px;\n  font-size: 16px;\n  line-height: 1.5;\n}\n\n.channel_actions {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.channel_button {\n  padding: 20px 24px;\n  background-color: var(--primary, #3b82f6);\n  color: white;\n  border: none;\n  border-radius: 12px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  width: 100%;\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.2);\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: -100%;\n    width: 100%;\n    height: 100%;\n    background: linear-gradient(\n      90deg,\n      transparent,\n      rgba(255, 255, 255, 0.2),\n      transparent\n    );\n    transition: 0.5s;\n  }\n\n  &:hover {\n    background-color: #2563eb;\n    transform: translateY(-2px);\n    box-shadow: 0 6px 16px rgba(59, 130, 246, 0.3);\n\n    &::before {\n      left: 100%;\n    }\n  }\n\n  &:active {\n    transform: translateY(0);\n    box-shadow: 0 2px 8px rgba(59, 130, 246, 0.2);\n  }\n}\n\n.sms_button {\n  background-color: #10b981;\n  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.2);\n\n  &:hover {\n    background-color: #059669;\n    box-shadow: 0 6px 16px rgba(16, 185, 129, 0.3);\n  }\n\n  &:active {\n    box-shadow: 0 2px 8px rgba(16, 185, 129, 0.2);\n  }\n}\n\n.button_icon {\n  font-size: 24px;\n  flex-shrink: 0;\n}\n\n.button_content {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  flex: 1;\n}\n\n.button_title {\n  font-size: 18px;\n  font-weight: 600;\n  margin-bottom: 2px;\n}\n\n.button_subtitle {\n  font-size: 14px;\n  font-weight: 400;\n  opacity: 0.9;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes popIn {\n  from {\n    opacity: 0;\n    transform: translate(-50%, -48%) scale(0.95);\n  }\n\n  to {\n    opacity: 1;\n    transform: translate(-50%, -50%) scale(1);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"channel_backdrop": `channel-prompt-modal_channel_backdrop__liCta`,
	"fadeIn": `channel-prompt-modal_fadeIn__OUe7o`,
	"channel_modal_overlay": `channel-prompt-modal_channel_modal_overlay__uDV9+`,
	"channel_modal": `channel-prompt-modal_channel_modal__r8Egd`,
	"popIn": `channel-prompt-modal_popIn__ts6c1`,
	"logo_container": `channel-prompt-modal_logo_container__rqLQB`,
	"channel_title": `channel-prompt-modal_channel_title__sYVpQ`,
	"channel_subtitle": `channel-prompt-modal_channel_subtitle__oxEe0`,
	"channel_actions": `channel-prompt-modal_channel_actions__Qn3fM`,
	"channel_button": `channel-prompt-modal_channel_button__MZTpR`,
	"sms_button": `channel-prompt-modal_sms_button__EG-G9`,
	"button_icon": `channel-prompt-modal_button_icon__qEWqz`,
	"button_content": `channel-prompt-modal_button_content__xbEJs`,
	"button_title": `channel-prompt-modal_button_title__F+Xfw`,
	"button_subtitle": `channel-prompt-modal_button_subtitle__Ss51O`
};
export default ___CSS_LOADER_EXPORT___;
